export default __webpack_public_path__ + "static/media/welcome-green.59e6f9f5.svg";